<template>
  <div class="d-flex">
    <div class="mr-1 mt-1">
      <p>{{ $t('Rows per page') }}:</p>
    </div>
    <div class="mr-2">
      <!-- <b-form-select id="rowsPerPage" v-model="pagination.perPage" @change="onOffsetChange">
        <b-form-select-option v-if="referenceTable === 'contractDefinitionTable'" value="5">5</b-form-select-option>
        <b-form-select-option value="20">20</b-form-select-option>
        <b-form-select-option value="50">50</b-form-select-option>
        <b-form-select-option value="100">100</b-form-select-option>
        <b-form-select-option v-if="pagination.largePerPage" v-model="pagination.largePerPage">
          {{ pagination.largePerPage }}
        </b-form-select-option>
      </b-form-select> -->
      <select
        id="rowsPerPage"
        class="form-select mt-1 w-5"
        :value="pagination.perPage"
        @change="onPaginationChange"
      >
        <option
          v-if="referenceTable === 'contractDefinitionTable'"
          value="5"
        >
          5
        </option>
        <option value="20">
          20
        </option>
        <option value="50">
          50
        </option>
        <option value="100">
          100
        </option>
        <option
          v-if="pagination.largePerPage"
          :value="pagination.largePerPage"
        >
          {{ pagination.largePerPage }}
        </option>
      </select>
    </div>
    <div
      v-if="$i18n.locale == 'hi'"
      class="mt-1"
    >
      <b-spinner
        v-if="isPaginationBusy"
        small
        variant="primary"
      />
      <span v-else>{{ totalRows || 0 }}</span>
      {{ $t('from') }} {{ paginationFrom }}-{{ paginationTo }}
    </div>
    <div
      v-else-if="$i18n.locale == 'en'"
      class="mt-1"
    >
      {{ paginationFrom }}-{{ paginationTo }} {{ $t('of') }}
      <b-spinner
        v-if="isPaginationBusy"
        small
        variant="primary"
      />
      <span v-else>{{ totalRows || 0 }}</span>
    </div>
    <div class="ml-auto mt-1">
      <b-pagination
        v-model="pagination.currentPage"
        size="sm"
        class="mb-0 float-right"
        :aria-controls="referenceTable"
        :prev-text="$t('Previous')"
        :next-text="$t('Next')"
        hide-goto-end-buttons
        :total-rows="totalRows"
        :per-page="pagination.perPage"
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    isPaginationBusy: { type: Boolean },
    paginationData: { type: Object },
    referenceTable: { type: String },
    totalRows: { type: Number }
  },
  emits: ['pageChange', 'onOffsetChange'],
  data () {
    return {
      pagination: { currentPage: 1, perPage: 20 }
    }
  },
  computed: {
    paginationFrom () {
      if (this.totalRows === 0) return 0
      return (this.pagination.currentPage - 1) * this.pagination.perPage + 1
    },
    paginationTo () {
      const end = this.pagination.currentPage * this.pagination.perPage
      return this.totalRows < end ? this.totalRows : end
    }
  },
  watch: {
    paginationData: function () {
      this.pagination = this.paginationData
    },
    totalRows: function () {
      this.pagination = this.paginationData
    }
  },
  methods: {
    onPaginationChange (event) {
      // 1. Get the selected value from the native event. NOTE: It will always be a STRING.
      const selectedValueString = event.target.value
      // 2. Manually update the data (what v-model did).
      // We use parseInt() to convert the string back to a number, which pagination.perPage almost certainly expects.
      const perPage = parseInt(selectedValueString, 10)
      this.pagination.perPage = perPage
      // 3. Now, call your original function
      this.onOffsetChange(perPage)
    },
    pageChange (newPage) {
      this.$emit('pageChange', newPage)
    },
    onOffsetChange (perPage) {
      this.pagination.currentPage = 1
      this.$emit('onOffsetChange', perPage)
    }
  }
}
</script>
